
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-oss/ledige-stillinger/[slug]",
      function () {
        return require("private-next-pages/om-oss/ledige-stillinger/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/om-oss/ledige-stillinger/[slug]"])
      });
    }
  